// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<nav inject=\"nav\"></nav>\n<div class=\"brec-container tablet-container--global\">\n  <main inject=\"content\"></main>\n  <aside inject=\"aside\"></aside>\n</div>\n<footer inject=\"footer\"></footer>\n";
},"useData":true});
